import { Link } from "react-router-dom";
import { SiteFooter } from "@/components/SiteFooter";
import { ArrowLeft } from "lucide-react";

const H = ({ children }) => <h2 className="font-heading text-lg font-bold text-primary mt-7 mb-2">{children}</h2>;
const P = ({ children }) => <p className="text-sm text-muted-foreground leading-relaxed mb-2">{children}</p>;

export default function MentionsLegales() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <main className="flex-1 mx-auto max-w-3xl w-full px-4 py-10" data-testid="page-mentions-legales">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground mb-6 hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Accueil</Link>
        <h1 className="font-heading text-3xl font-bold">Mentions légales</h1>

        <H>Éditeur du site</H>
        <P>SELARL Pharmacie des Écoles<br/>Forme juridique : SELARL (société d'exercice libéral à responsabilité limitée)<br/>Capital social : 120 000,00 €<br/>Siège social : 8 place André Allègre, 83250 La Londe-les-Maures<br/>RCS : 488 235 227 R.C.S. Toulon — SIRET (siège) : 488 235 227 00011<br/>N° TVA intracommunautaire : FR67488235227<br/>Téléphone : 04 94 66 81 57 — Contact : via le formulaire de contact du site</P>

        <H>Directeur de la publication</H>
        <P>M. Michael DAYAN, pharmacien titulaire</P>

        <H>Hébergeur</H>
        <P>Emergent Labs Inc.<br/>2380 Via Espada, Pleasanton, CA 94566, États-Unis</P>
      </main>
      <SiteFooter />
    </div>
  );
}
